import { useContext, useOnDocument, $, useStore } from '@builder.io/qwik';
import { format } from 'timeago.js';
import { AppDataContext } from '~/contexts/AppDataContext';

export function useArticleDate(dateString?: string) {
  const {
    payloadToSSR: { propertySettings },
  } = useContext(AppDataContext);
  const { IANATimezoneName, locale } = propertySettings;
  const dateStringFormatted = useStore({ value: '' });

  if (!dateString) return dateString;

  useOnDocument(
    'load',
    $(() => {
      const date = new Date(dateString);
      const now = new Date();
      const twentyFourHoursAgo = new Date(now.getTime() - 24 * 60 * 60 * 1000);

      if (date < twentyFourHoursAgo) {
        dateStringFormatted.value = date.toLocaleDateString(locale || 'en-US', {
          timeZone: IANATimezoneName || 'America/New_York',
          month: 'short',
          day: 'numeric',
          year: 'numeric',
        });
      } else {
        dateStringFormatted.value = format(date, locale);
      }
    })
  );

  return dateStringFormatted.value;
}
